import {useState} from 'react';
import PropTypes from 'prop-types';

import StyledCard from "components/card/StyledCard";

import FoldableHeader from './FoldableHeader';
import FoldableContent from './FoldableContent';
import ScoreGrid from './ScoreGrid';
import SuggestionBox from './SuggestionBox';
import ActionBar from './ActionBar';


FoldableItem.propTypes = {
    title: PropTypes.string.isRequired,
    impact: PropTypes.number,
    source: PropTypes.string,
    status: PropTypes.bool,
    scores: PropTypes.object,
    suggestion: PropTypes.string,
    defaultOpen: PropTypes.bool,
    onGenerate: PropTypes.func,
    onEdit: PropTypes.func,
    onValidate: PropTypes.func,
    onCancel: PropTypes.func,
};

function FoldableItem({
    title = '',
    impact = 0,
    source = '',
    status = false,
    scores = {},
    suggestion = null,
    defaultOpen = false,
    onGenerate = () => {},
    onEdit = () => {},
    onValidate = () => {},
    onCancel = () => {},
}) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <StyledCard
            noHoverShadow
            style={{
                overflow: "hidden",
                padding: 0
            }}
        >
            <FoldableHeader
                title={title}
                impact={impact}
                source={source}
                status={status}
                open={open}
                onClick={() => setOpen(!open)}
            />

            <FoldableContent open={open}>
                <ScoreGrid scores={scores}/>
                {suggestion && (
                    <SuggestionBox text={suggestion}/>
                )}
                <ActionBar
                    onGenerate={onGenerate}
                    onEdit={onEdit}
                    onValidate={onValidate}
                    onCancel={onCancel}
                />
            </FoldableContent>
        </StyledCard>
    );
}


export default FoldableItem;
